module.exports = __webpack_public_path__ + "assets/img/7.bb4224d4.png";